import React, { useEffect, useState } from "react";
import { Mui } from '@osu/react-ui'
import Informational from "../../Common/components/Informational";
import { APPLICATION_NAME } from "../../util/constants";
import { useDispatch } from "react-redux";
import { handleLogout } from "../../services/authorization/thunks";

const LogOut = () => {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  let info = `Signing out of ${APPLICATION_NAME}`;
  if (!isLoading) {
    info = `Signed out of ${APPLICATION_NAME}`;
  }

  useEffect(() => {
    const performLogout = async () => {
      setIsLoading(true);
      try {
        await dispatch(handleLogout()).unwrap();
      } catch (error) {
        console.error("Logout failed:", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    performLogout();
  }, [dispatch]);

  return (
    <Informational info={info} childrenFirst={true} infoComponent="h2">
      {isLoading && 
        <Mui.Box className="margin-right-4">
           <Mui.CircularProgress />
        </Mui.Box>
      }
    </Informational>
  );
};

export default LogOut;